module.exports = __webpack_public_path__ + "static/img/userCard.69b73bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/userCard.png
// module id = GBGA
// module chunks = 18